<script>
  import { onMount } from "svelte";

  let canvas;

  onMount(() => {
    let ctx = canvas.getContext("2d");

    var col = function (x, y, r, g, b) {
      ctx.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
      ctx.fillRect(x, y, 1, 1);
    };
    var R = function (x, y, t) {
      return Math.floor(192 + 64 * Math.cos((x * x - y * y) / 300 + t));
    };

    var G = function (x, y, t) {
      return Math.floor(
        192 +
          64 *
            Math.sin((x * x * Math.cos(t / 4) + y * y * Math.sin(t / 3)) / 300),
      );
    };

    var B = function (x, y, t) {
      return Math.floor(
        192 +
          64 *
            Math.sin(
              5 * Math.sin(t / 9) +
                ((x - 100) * (x - 100) + (y - 100) * (y - 100)) / 1100,
            ),
      );
    };

    var t = 0;
    var x;
    var y;

    var run = function () {
      for (x = 0; x <= 35; x++) {
        for (y = 0; y <= 35; y++) {
          col(x, y, R(x, y, t), G(x, y, t), B(x, y, t));
        }
      }
      t = t + 0.012;
      window.requestAnimationFrame(run);
    };

    run();
  });
</script>

<!-- <canvas width="32" height="32" bind:this={canvas}></canvas> -->
<canvas
  width="32"
  height="32"
  bind:this={canvas}
  style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: -9999; filter: saturate(0.35);"
>
</canvas>
